import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router";
import { CHEVRON_DOWN_SVG } from '../assets';
var Hamburger = function (props) {
    var _a = useState(''), selectedCategory = _a[0], setSelectedCategory = _a[1];
    var liRef = useRef(null);
    var history = useHistory();
    // Close any open categories on hitting cancel button
    useEffect(function () {
        if (!props.burgerOpen) {
            setSelectedCategory('');
        }
    }, [props.burgerOpen]);
    var toggleCategory = function (categoryName) {
        if (categoryName &&
            categoryName === selectedCategory)
            setSelectedCategory('');
        else
            setSelectedCategory(categoryName);
    };
    return (React.createElement("div", { className: "HamburgerMenu " + (props.burgerOpen ? 'open' : '') },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "menus" }, props.navItems.map(function (cat, index) {
                var category = cat;
                var categoryName = cat.category_name;
                var categoryHeight = liRef.current && category.items.length * 43;
                return (React.createElement("div", { key: index, className: "category-wrapper" },
                    React.createElement("div", { className: "divider" }),
                    React.createElement("div", { className: "category no-select", onClick: function () { return toggleCategory(categoryName); } },
                        React.createElement("span", { className: "text" }, categoryName),
                        React.createElement("img", { className: "chevron " + (categoryName === selectedCategory ? 'selected' : ''), src: CHEVRON_DOWN_SVG, alt: "chevron" })),
                    React.createElement("ul", { className: "no-select " + (categoryName === selectedCategory ? 'selected' : ''), id: index === 0 ? 'first' : '', style: (categoryName === selectedCategory) && (categoryHeight) ? { height: categoryHeight } : { height: 0 } }, category.items.map(function (item) {
                        return (React.createElement("li", { onClick: function () { item.path ? history.push(item.path) : history.push('/'); }, key: item.path, ref: liRef },
                            React.createElement("span", { className: "text" }, item.text)));
                    }))));
            })))));
};
export default Hamburger;
//# sourceMappingURL=HamburgerMenu.js.map